import { Injectable } from '@angular/core';
import { getHeaders } from '../utils/geral';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState, selectGruposKeycloak } from '../store';
import { UsuarioGrupoAdd } from '../store/grupo/usuario-grupo.actions';
import {Customizacao, GrupoKeycloak} from '../models/usuario/grupo-keycloak';
import { firstValueFrom } from 'rxjs';
import { ShareDataService } from './share-data.service';

@Injectable({
  providedIn: 'root',
})
export class GruposService {
  uri = environment.urlApi.concat('/v1');
  grupos: any = null;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private shareDataService: ShareDataService
  ) {}

  private getGroupsApi(tenant?: string): Promise<GrupoKeycloak[]> {
    let uri = tenant
      ? `${this.uri}/usuario/grupos?tenant=${tenant}`
      : `${this.uri}/usuario/grupos`;

    return firstValueFrom(
      this.http.get<GrupoKeycloak[]>(uri, { headers: getHeaders() })
    );
  }

  listGroups(tenant?: string): Promise<GrupoKeycloak[]> {
    return new Promise<GrupoKeycloak[]>((resolve, reject) => {
      if (tenant) {
        resolve(this.getGroupsApi(tenant));
      }

      this.store.select(selectGruposKeycloak).subscribe((selectGrupos: any) => {
        if (selectGrupos && selectGrupos.length && selectGrupos.length > 0) {
          this.grupos = selectGrupos;
        }
      });

      if (this.grupos && this.grupos.length && this.grupos.length > 0) {
        resolve(this.grupos);
      } else {
        let prom = this.getGroupsApi(tenant);

        prom.then((gs) => {
          this.grupos = gs;
          this.store.dispatch(new UsuarioGrupoAdd({ grupos: gs }));
          resolve(this.grupos);
        });
      }
    });
  }

  async verificaPermissaoMenu(
    menu: any,
    cedente?: any,
    idEmpresa?: any,
    tenant?: any
  ) {
    return new Promise<boolean>((resolve, reject) => {
      if (!menu || menu.length == 0) resolve(false);

      this.listGroups(tenant).then((grupos) => {
        let x =
          grupos &&
          grupos.findIndex((g: any) => {
            if (!g || !g.name) return;
             
            let spl: string[] = g.name.split(':');

            // o padrão do nome será 'tenant:idEmpresa:idPerfil:documento'

            let c1 = !tenant || tenant.length == 0 || spl[0] == tenant;
            let c2 = !idEmpresa || idEmpresa.length == 0 || spl[1] == idEmpresa;
            let c3 = !cedente || cedente.length == 0 || spl[3] == cedente;
            let c4 = g.atributtes
              ? g.atributtes.findIndex((a: any) => a == menu) >= 0
              : false;
            return c1 && c2 && c3 && c4;
          });

        resolve(x >= 0);
      });
    }).then((p) => {
      return p;
    });
  }

  async verificaPermissaoAoAlterarSelect(
    menu: string,
    modelForm: any,
    visao: string
  ): Promise<boolean> {
    if (modelForm.carteira?.length > 0) {
      if (visao === 'sacado') {
        return await this.verificaPermissaoSacado(menu, modelForm);
      } else {
        return await this.verificaPermissaoCedente(menu, modelForm);
      }
    }

    return false;
  }

  async verificaPermissaoSacado(
    menu: string,
    modelForm: any
  ): Promise<boolean> {
    let resPermiss: boolean[] = [];
    const idList = modelForm.carteira.map((m: any) => m.id);

    for (const person of modelForm.sacado) {
      for (const id of idList) {
        try {
          const response = await this.verificaPermissaoMenu(
            menu,
            person.id,
            id.split(':')[1],
            id.split(':')[0]
          );
          resPermiss.push(response);
          if (response) {
            this.shareDataService.share(true);
          }
        } catch (error) {
          console.error(`Erro ao processar`, error);
        }
      }
    }
    return resPermiss.some((value) => value === true);
  }

  async verificaPermissaoCedente(
    menu: string,
    modelForm: any
  ): Promise<boolean> {
    if (!modelForm && !modelForm.carteira) return false;

    if (
      modelForm.carteira &&
      modelForm.carteira.length == 1 &&
      modelForm.carteira[0] == null
    )
      return false;

    let resPermiss: boolean[] = [];
    const idList = modelForm.carteira.map((m: any) => m.id);

    for (const person of modelForm.cedente) {
      for (const id of idList) {
        try {
          const response = await this.verificaPermissaoMenu(
            menu,
            person.id,
            id.split(':')[1],
            id.split(':')[0]
          );
          resPermiss.push(response);
          if (response) {
            this.shareDataService.share({ person: person, id });
          }
        } catch (error) {
          console.error(`Erro ao processar`, error);
        }
      }
    }

    return resPermiss.some((value) => value === true);
  }

  //Retorna as customizações disponíveis para um cliente pela tenant informada
 async getCustomizacoes(tenant: string): Promise<Customizacao[]> {
    return this.listGroups(tenant).then((groups) => {
      return groups
        .filter((group) => group && group.customizacao)
        .map((group) => group.customizacao as Customizacao);
    });
  }
}
